module.exports = __webpack_public_path__ + "static/img/3_1_2_4.0dc9ae85.jpg";